export const mapAndMergeMetrics = (
  items: any[],
  fieldMap: Record<string, string>,
  mergeMap?: Record<string, string[]>,
): any[] => {
  return items.map((item) => {
    const mapped: Record<string, any> = {};

    for (const [key, value] of Object.entries(item)) {
      const mappedKey = fieldMap[key] || key;

      if (typeof value === 'number') {
        mapped[mappedKey] = (mapped[mappedKey] || 0) + value;
      } else {
        mapped[mappedKey] = value;
      }
    }

    if (mergeMap) {
      for (const [newKey, oldKeys] of Object.entries(mergeMap)) {
        if (oldKeys.some((k) => k in item)) {
          mapped[newKey] = oldKeys.reduce((sum, oldKey) => {
            const val = item[oldKey];
            return sum + (typeof val === 'number' ? val : 0);
          }, 0);
        }
      }
    }

    return mapped;
  });
};
